const Versions = {
    version: '2.3.1'
}
export default Versions